// extracted by mini-css-extract-plugin
export var errorIcon = "_p7-1";
export var nameLogo = "_p7-0";